import { ExamFRQType, ExamTypeEnum } from "@knowt/syncing/graphql/schema";

export type ExamBreakdown = {
    max: number;
    scores: number[];
    specificFRQ?: boolean;
    sections: {
        name: string;
        time: number;
        sectionPoints: number;
        sectionTotal: number;
        breakdown: {
            name: string;
            description?: string;
            type: ExamTypeEnum;
            frqType?: ExamFRQType;
            points: number;
            total: number;
        }[];
    }[];
};

export const EXAM_SCORE_DATA: Record<string, ExamBreakdown> = {
    "AP Biology": {
        max: 120,
        scores: [0, 28, 51, 74, 93],
        sections: [
            {
                name: "Section 1",
                time: 60,
                sectionPoints: 60,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 60,
                        total: 60,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 90,
                sectionPoints: 36,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        description: "FRQ 1: Interpret and Evaluate Experimental Results (Long)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 16.666,
                    },
                    {
                        name: "Free Response - Question 2",
                        description: "FRQ 2: Interpret and Evaluate Experimental Results (Long)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 16.666,
                    },
                    {
                        name: "Free Response - Question 3",
                        description: "FRQ 3: Scientific investigation (Short)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 6.666,
                    },
                    {
                        name: "Free Response - Question 4",
                        description: "FRQ 4: Conceptual Analysis (Short)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 6.666,
                    },
                    {
                        name: "Free Response - Question 5",
                        description: "FRQ 5: Analysis of Model or Visual Representation (Short)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 6.666,
                    },
                    {
                        name: "Free Response - Question 6",
                        description: "FRQ 6: Data analysis (Short)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 6.666,
                    },
                ],
            },
        ],
    },
    "AP United States Government and Politics": {
        max: 120,
        scores: [0, 53, 73, 91, 99],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 55,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 55,
                        total: 60,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 100,
                sectionPoints: 17,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        description: "FRQ 1: Concept Application",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.CONCEPT_APPLICATION,
                        points: 3,
                        total: 15,
                    },
                    {
                        name: "Free Response - Question 2",
                        description: "FRQ 2: Concept Application",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.CONCEPT_APPLICATION,
                        points: 4,
                        total: 15,
                    },
                    {
                        name: "Free Response - Question 3",
                        description: "FRQ 3: SCOTUS Comparison",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SCOTUS_COMPARISON,
                        points: 4,
                        total: 15,
                    },
                    {
                        name: "Free Response - Question 4",
                        description: "FRQ 4: Argument Essay",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.ARGUMENTATIVE_ESSAY,
                        points: 6,
                        total: 15,
                    },
                ],
            },
        ],
    },
    "AP Human Geography": {
        max: 120,
        scores: [0, 47, 58, 70, 84],
        sections: [
            {
                name: "Section 1",
                time: 60,
                sectionPoints: 60,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 60,
                        total: 60,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 75,
                sectionPoints: 21,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.HUG_NO_STIMULUS,
                        points: 7,
                        total: 20,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.HUG_NO_STIMULUS,
                        points: 7,
                        total: 20,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.HUG_NO_STIMULUS,
                        points: 7,
                        total: 20,
                    },
                ],
            },
        ],
    },
    "AP European History": {
        max: 130,
        scores: [0, 44, 63, 80, 97],
        specificFRQ: true,
        sections: [
            {
                name: "Section 1",
                time: 0,
                sectionPoints: 64,
                sectionTotal: 78,
                breakdown: [
                    {
                        name: "Part A - Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 55,
                        total: 52,
                    },
                    {
                        name: "Part B - Short-Answer Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                    {
                        name: "Part B - Short-Answer Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                    {
                        name: "Part B - Short-Answer Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 100,
                sectionPoints: 13,
                sectionTotal: 52,
                breakdown: [
                    {
                        name: "Part A - Document-Based Question (DBQ)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.DBQ,
                        points: 7,
                        total: 32,
                    },
                    {
                        name: "Part B - Long-Essay Question (LEQ)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 20,
                    },
                ],
            },
        ],
    },
    "AP World History: Modern": {
        max: 130,
        scores: [0, 44, 63, 80, 97],
        specificFRQ: true,
        sections: [
            {
                name: "Section 1",
                time: 95,
                sectionPoints: 64,
                sectionTotal: 78,
                breakdown: [
                    {
                        name: "Part A - Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 55,
                        total: 52,
                    },
                    {
                        name: "Part B - Short-Answer Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                    {
                        name: "Part B - Short-Answer Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                    {
                        name: "Part B - Short-Answer Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 100,
                sectionPoints: 13,
                sectionTotal: 52,
                breakdown: [
                    {
                        name: "Part A - Document-Based Question (DBQ)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.DBQ,
                        points: 7,
                        total: 32,
                    },
                    {
                        name: "Part B - Long-Essay Question (LEQ)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 20,
                    },
                ],
            },
        ],
    },
    "AP Macroeconomics": {
        max: 90,
        scores: [0, 38, 49, 57, 73],
        sections: [
            {
                name: "Section 1",
                time: 70,
                sectionPoints: 60,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 60,
                        total: 60,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 60,
                sectionPoints: 20,
                sectionTotal: 30,
                breakdown: [
                    {
                        name: "Free Response - Q1 - Long",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_ECON_LONG,
                        points: 10,
                        total: 15.333,
                    },
                    {
                        name: "Free Response - Q2 - Short",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_ECON_SHORT,
                        points: 5,
                        total: 7.333,
                    },
                    {
                        name: "Free Response - Q3 - Short",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_ECON_SHORT,
                        points: 5,
                        total: 7.333,
                    },
                ],
            },
        ],
    },
    "AP United States History": {
        max: 130,
        scores: [0, 44, 63, 80, 97],
        specificFRQ: true,
        sections: [
            {
                name: "Section 1",
                time: 95,
                sectionPoints: 64,
                sectionTotal: 78,
                breakdown: [
                    {
                        name: "Part A - Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 55,
                        total: 52,
                    },
                    {
                        name: "Part B - Short-Answer Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                    {
                        name: "Part B - Short-Answer Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                    {
                        name: "Part B - Short-Answer Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 3,
                        total: 8.666,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 100,
                sectionPoints: 13,
                sectionTotal: 52,
                breakdown: [
                    {
                        name: "Part A - Document-Based Question (DBQ)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.DBQ,
                        points: 7,
                        total: 32,
                    },
                    {
                        name: "Part B - Long-Essay Question (LEQ)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 20,
                    },
                ],
            },
        ],
    },
    "AP Microeconomics": {
        max: 90,
        scores: [0, 39, 50, 62, 75],
        sections: [
            {
                name: "Section 1",
                time: 70,
                sectionPoints: 60,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 60,
                        total: 60,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 60,
                sectionPoints: 20,
                sectionTotal: 30,
                breakdown: [
                    {
                        name: "Free Response - Q1 - Long",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_ECON_LONG,
                        points: 10,
                        total: 15.333,
                    },
                    {
                        name: "Free Response - Q2 - Short",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_ECON_SHORT,
                        points: 5,
                        total: 7.333,
                    },
                    {
                        name: "Free Response - Q3 - Short",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_ECON_SHORT,
                        points: 5,
                        total: 7.333,
                    },
                ],
            },
        ],
    },
    "AP Computer Science Principles": {
        max: 100,
        scores: [0, 45, 62, 81, 90],
        sections: [
            {
                name: "Section 1",
                time: 120,
                sectionPoints: 70,
                sectionTotal: 70,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 70,
                        total: 70,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 0,
                sectionPoints: 6,
                sectionTotal: 30,
                breakdown: [
                    {
                        name: "Create Performance Task",
                        type: ExamTypeEnum.FRQ,
                        points: 6,
                        total: 30,
                    },
                ],
            },
        ],
    },
    "AP Comparative Government and Politics": {
        max: 120,
        scores: [0, 43, 60, 72, 84],
        sections: [
            {
                name: "Section 1",
                time: 60,
                sectionPoints: 55,
                sectionTotal: 60,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 55,
                        total: 60,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 90,
                sectionPoints: 19,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Free Response - Conceptual Analysis",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.COMPARATIVE_ANALYSIS,
                        points: 4,
                        total: 13,
                    },
                    {
                        name: "Free Response - Conceptual Analysis",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.COMPARATIVE_ANALYSIS,
                        points: 5,
                        total: 15,
                    },
                    {
                        name: "Free Response - Comparative Analysis",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.COMPARATIVE_ANALYSIS,
                        points: 5,
                        total: 15,
                    },
                    {
                        name: "Free Response - Argument Essay",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.ARGUMENTATIVE_ESSAY,
                        points: 5,
                        total: 17,
                    },
                ],
            },
        ],
    },
    "AP Environmental Science": {
        max: 130,
        scores: [0, 50, 68, 77, 96],
        sections: [
            {
                name: "Section 1",
                time: 90,
                sectionPoints: 80,
                sectionTotal: 78,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 80,
                        total: 78,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 70,
                sectionPoints: 30,
                sectionTotal: 52,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 17.333,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 17.333,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 17.333,
                    },
                ],
            },
        ],
    },
    "AP Statistics": {
        max: 100,
        scores: [0, 29, 37, 49, 63],
        sections: [
            {
                name: "Section 1",
                time: 90,
                sectionPoints: 40,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 40,
                        total: 50,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 90,
                sectionPoints: 24,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_STATS_GENERIC,
                        points: 4,
                        total: 7.4,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_STATS_GENERIC,
                        points: 4,
                        total: 7.4,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_STATS_GENERIC,
                        points: 4,
                        total: 7.4,
                    },
                    {
                        name: "Free Response - Question 4",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_STATS_GENERIC,
                        points: 4,
                        total: 7.4,
                    },
                    {
                        name: "Free Response - Question 5",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_STATS_GENERIC,
                        points: 4,
                        total: 7.4,
                    },
                    {
                        name: "Free Response - Question 6 - Investigative Task",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_STATS_INVESTIGATIVE,
                        points: 4,
                        total: 13,
                    },
                ],
            },
        ],
    },
    // "AP Art History": {
    //     max: 200,
    //     scores: [0, 72, 90, 113, 142],
    //     specificFRQ: true,
    //     sections: [
    //         {
    //             name: "Section 1",
    //             time: 80,
    //             sectionPoints: 80,
    //             sectionTotal: 100,
    //             breakdown: [
    //                 {
    //                     name: "Multiple Choice",
    //                     type: ExamTypeEnum.MCQ,
    //                     points: 80,
    //                     total: 100,
    //                 },
    //             ],
    //         },
    //         {
    //             name: "Section 2",
    //             time: 120,
    //             sectionPoints: 33,
    //             sectionTotal: 100,
    //             breakdown: [
    //                 {
    //                     name: "Free Response - Comparison",
    //                     type: ExamTypeEnum.FRQ,
    //                     frqType: ExamFRQType.LEQ,
    //                     points: 8,
    //                     total: 23,
    //                 },
    //                 {
    //                     name: "Free Response - Visual/Contextual Analysis",
    //                     type: ExamTypeEnum.FRQ,
    //                     frqType: ExamFRQType.LEQ,
    //                     points: 6,
    //                     total: 17,
    //                 },
    //                 {
    //                     name: "Free Response - Visual Analysis",
    //                     type: ExamTypeEnum.FRQ,
    //                     frqType: ExamFRQType.SAQ,
    //                     points: 5,
    //                     total: 15,
    //                 },
    //                 {
    //                     name: "Free Response - Contextual Analysis",
    //                     type: ExamTypeEnum.FRQ,
    //                     frqType: ExamFRQType.SAQ,
    //                     points: 5,
    //                     total: 15,
    //                 },
    //                 {
    //                     name: "Free Response - Attribution",
    //                     type: ExamTypeEnum.FRQ,
    //                     frqType: ExamFRQType.SAQ,
    //                     points: 5,
    //                     total: 15,
    //                 },
    //                 {
    //                     name: "Free Response - Continuity and Change",
    //                     type: ExamTypeEnum.FRQ,
    //                     frqType: ExamFRQType.SAQ,
    //                     points: 5,
    //                     total: 15,
    //                 },
    //             ],
    //         },
    //     ],
    // },
    "AP Computer Science A": {
        max: 80,
        scores: [0, 29, 37, 47, 62],
        sections: [
            {
                name: "Section 1",
                time: 90,
                sectionPoints: 40,
                sectionTotal: 40,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 40,
                        total: 40,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 90,
                sectionPoints: 36,
                sectionTotal: 40,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.APCSA_MCS,
                        points: 9,
                        total: 10,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.APCSA_CLASS_DESIGN,
                        points: 9,
                        total: 10,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.APCSA_ARRAYS,
                        points: 9,
                        total: 10,
                    },
                    {
                        name: "Free Response - Question 4",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.APCSA_TWOD_ARRAYS,
                        points: 9,
                        total: 10,
                    },
                ],
            },
        ],
    },
    "AP Calculus AB": {
        max: 108,
        scores: [0, 37, 45, 57, 69],
        sections: [
            {
                name: "Section 1",
                time: 105,
                sectionPoints: 45,
                sectionTotal: 54,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 45,
                        total: 54,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 90,
                sectionPoints: 54,
                sectionTotal: 54,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_WITH_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_WITH_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 4",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 5",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 6",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                ],
            },
        ],
    },
    "AP Calculus BC": {
        max: 108,
        scores: [0, 35, 41, 52, 62],
        sections: [
            {
                name: "Section 1",
                time: 105,
                sectionPoints: 45,
                sectionTotal: 54,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 45,
                        total: 54,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 105,
                sectionPoints: 46,
                sectionTotal: 52,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_WITH_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_WITH_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 4",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 5",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Question 6",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 9,
                        total: 9,
                    },
                ],
            },
        ],
    },
    "AP Psychology": {
        max: 114,
        scores: [0, 44, 54, 63, 75],
        sections: [
            {
                name: "Section 1",
                time: 90,
                sectionPoints: 100,
                sectionTotal: 76,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 100,
                        total: 76,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 70,
                sectionPoints: 14,
                sectionTotal: 38,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.PSYCH_CONCEPT_APPLICATION,
                        points: 7,
                        total: 19,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.PSYCH_RESEARCH_DESIGN,
                        points: 7,
                        total: 19,
                    },
                ],
            },
        ],
    },
    "AP English Language and Composition": {
        max: 100,
        scores: [0, 36, 53, 65, 75],
        sections: [
            {
                name: "Section 1",
                time: 60,
                sectionPoints: 45,
                sectionTotal: 45,
                breakdown: [
                    {
                        name: "Multiple Choice: Reading",
                        type: ExamTypeEnum.MCQ,
                        points: 45,
                        total: 45,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 135,
                sectionPoints: 18,
                sectionTotal: 55,
                breakdown: [
                    {
                        name: "Free Response - Q1 - Synthesis",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 18.333,
                    },
                    {
                        name: "Free Response - Q2 - Rhetorical Analysis",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 18.333,
                    },
                    {
                        name: "Free Response - Q3 - Argument",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 18.333,
                    },
                ],
            },
        ],
    },
    "AP Music Theory": {
        max: 200,
        scores: [0, 63, 91, 115, 140],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 75,
                sectionTotal: 90,
                breakdown: [
                    {
                        name: "Multiple Choice - Aural",
                        type: ExamTypeEnum.MCQ,
                        points: 42,
                        total: 45,
                    },
                    {
                        name: "Multiple Choice - Nonaural",
                        type: ExamTypeEnum.MCQ,
                        points: 33,
                        total: 45,
                    },
                ],
                // Note: The College Board does not explicitly separate multiple choice into two sections (Aural and Nonaural).
            },
            {
                name: "Section 2",
                time: 80,
                sectionPoints: 130,
                sectionTotal: 110,
                breakdown: [
                    {
                        name: "Free Response - Melodic Dictation Q1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Melodic Dictation Q2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Free Response - Harmonic Dictation Q1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 24,
                        total: 9,
                    },
                    {
                        name: "Free Response - Harmonic Dictation Q2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 24,
                        total: 9,
                    },
                    {
                        name: "Part Writing from Figured Bass Q5",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 25,
                        total: 19,
                    },
                    {
                        name: "Section II: Free Response - Part Writing from Roman Numerals Q6",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 18,
                        total: 14,
                    },
                    {
                        name: "Section II: Free Response - Harmonization of a Melody Q7",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 9,
                        total: 23,
                    },
                    {
                        name: "Section II: Free Response - Sight-singing Q1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 9,
                        total: 9,
                    },
                    {
                        name: "Section II: Free Response - Sight-singing Q2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 9,
                        total: 9,
                    },
                ],
            },
        ],
    },
    "AP English Literature and Composition": {
        max: 150,
        scores: [0, 53, 81, 98, 114],
        sections: [
            {
                name: "Section 1",
                time: 60,
                sectionPoints: 55,
                sectionTotal: 67,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 55,
                        total: 67,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 120,
                sectionPoints: 18,
                sectionTotal: 83,
                breakdown: [
                    {
                        name: "Free Response - Q1 - Poetry Analysis",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 27.666,
                    },
                    {
                        name: "Free Response - Q2 - Prose Fiction Analysis",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 27.666,
                    },
                    {
                        name: "Free Response - Q3 - Literary Argument",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 27.666,
                    },
                ],
            },
        ],
    },
    "AP Chemistry": {
        max: 100,
        scores: [0, 27, 42, 58, 72],
        sections: [
            {
                name: "Section 1",
                time: 90,
                sectionPoints: 60,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 60,
                        total: 50,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 105,
                sectionPoints: 42,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 11.333,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 11.333,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 11.333,
                    },
                    {
                        name: "Free Response - Question 4",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 4,
                    },
                    {
                        name: "Free Response - Question 5",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 4,
                    },
                    {
                        name: "Free Response - Question 6",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 4,
                    },
                    {
                        name: "Free Response - Question 7",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 4,
                        total: 4,
                    },
                ],
            },
        ],
    },
    "AP Physics C: Mechanics": {
        max: 90,
        scores: [0, 23, 31, 39, 50],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 35,
                sectionTotal: 45,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 35,
                        total: 45,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 45,
                sectionPoints: 45,
                sectionTotal: 45,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 15,
                        total: 15,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 15,
                        total: 15,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 15,
                        total: 15,
                    },
                ],
                // Note: There are 4 free-response questions, each 25 minutes long, according to College Board documentation.
            },
        ],
    },
    "AP French Language and Culture": {
        max: 160,
        scores: [0, 73, 90, 113, 128],
        sections: [
            {
                name: "Section 1",
                time: 95,
                sectionPoints: 65,
                sectionTotal: 80,
                breakdown: [
                    {
                        name: "Multiple Choice - Part A",
                        type: ExamTypeEnum.MCQ,
                        points: 30,
                        total: 37,
                    },
                    {
                        name: "Multiple Choice - Part B",
                        type: ExamTypeEnum.MCQ,
                        points: 35,
                        total: 43,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 92,
                sectionPoints: 20,
                sectionTotal: 80,
                breakdown: [
                    {
                        name: "Free Response - Interpersonal Writing",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 20,
                    },
                    {
                        name: "Free Response - Presentational Writing",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 5,
                        total: 20,
                    },
                    {
                        name: "Free Response - Interpersonal Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 5,
                        total: 20,
                    },
                    {
                        name: "Free Response - Presentational Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was PS, replaced with SAQ as PS is not valid.
                        points: 5,
                        total: 20,
                    },
                ],
            },
        ],
    },
    "AP Physics C: Electricity and Magnetism": {
        max: 90,
        scores: [0, 21, 32, 40, 53],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 35,
                sectionTotal: 45,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 35,
                        total: 45,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 45,
                sectionPoints: 45,
                sectionTotal: 45,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 15,
                        total: 15,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 15,
                        total: 15,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 15,
                        total: 15,
                    },
                ],
            },
        ],
    },
    "AP Precalculus": {
        max: 100,
        scores: [0, 31, 42, 55, 67],
        sections: [
            {
                name: "Section 1",
                time: 120,
                sectionPoints: 40,
                sectionTotal: 63,
                breakdown: [
                    {
                        name: "Multiple Choice - Part A",
                        type: ExamTypeEnum.MCQ,
                        points: 28,
                        total: 44,
                    },
                    {
                        name: "Multiple Choice - Part B",
                        type: ExamTypeEnum.MCQ,
                        points: 12,
                        total: 19,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 60,
                sectionPoints: 24,
                sectionTotal: 37,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_WITH_CALC,
                        points: 6,
                        total: 9.25,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_WITH_CALC,
                        points: 6,
                        total: 9.25,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 6,
                        total: 9.25,
                    },
                    {
                        name: "Free Response - Question 4",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_CALC_NO_CALC,
                        points: 6,
                        total: 9.25,
                    },
                ],
            },
        ],
    },
    "AP Physics 1: Algebra-Based": {
        max: 100,
        scores: [0, 25, 40, 54, 70],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 50,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 50,
                        total: 50,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 90,
                sectionPoints: 47,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Free-Response (Experimental Design)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 12,
                        total: 13,
                    },
                    {
                        name: "Free-Response (Qualitative/Quantitative Translation)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 12,
                        total: 13,
                    },
                    {
                        name: "Free-Response (Paragraph Argument)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 7,
                        total: 8,
                    },
                    {
                        name: "Free-Response (Short Answer 1)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 7,
                        total: 8,
                    },
                    {
                        name: "Free-Response (Short Answer 2)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 7,
                        total: 8,
                    },
                ],
            },
        ],
    },
    "AP Physics 2: Algebra-Based": {
        max: 100,
        scores: [0, 22, 41, 60, 72],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 50,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 50,
                        total: 50,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 100,
                sectionPoints: 44,
                sectionTotal: 50,
                breakdown: [
                    {
                        name: "Free-Response - Experimental Design",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 12,
                        total: 14,
                    },
                    {
                        name: "Free-Response - Quantitative/Qualitative Translation",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 12,
                        total: 14,
                    },
                    {
                        name: "Free-Response - Paragraph Argument",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 11,
                    },
                    {
                        name: "Free-Response (Short Answer)",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.AP_SCIENCE_FRQ_GENERIC,
                        points: 10,
                        total: 11,
                    },
                ],
            },
        ],
    },
    "AP German Language and Culture": {
        max: 200,
        scores: [0, 89, 117, 147, 171],
        sections: [
            {
                name: "Section 1",
                time: 95,
                sectionPoints: 65,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 30,
                        total: 46,
                    },
                    {
                        name: "Multiple Choice with Audio",
                        type: ExamTypeEnum.MCQ,
                        points: 35,
                        total: 54,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 92,
                sectionPoints: 20,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Free Response - Interpersonal Writing",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 25,
                    },
                    {
                        name: "Free Response - Presentational Writing",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 25,
                    },
                    {
                        name: "Free Response - Interpersonal Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 5,
                        total: 25,
                    },
                    {
                        name: "Free Response - Presentational Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 25,
                    },
                ],
            },
        ],
    },
    "AP Latin": {
        max: 120,
        scores: [0, 44, 57, 73, 83],
        sections: [
            {
                name: "Section 1",
                time: 60,
                sectionPoints: 49,
                sectionTotal: 48,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 49,
                        total: 48,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 120,
                sectionPoints: 36,
                sectionTotal: 72,
                breakdown: [
                    {
                        name: "Free Response - Question 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 9,
                        total: 11,
                    },
                    {
                        name: "Free Response - Question 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 9,
                        total: 11,
                    },
                    {
                        name: "Free Response - Question 3",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 6,
                        total: 24.5,
                    },
                    {
                        name: "Free Response - Question 4",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 6,
                        total: 24.5,
                    },
                    {
                        name: "Free Response - Question 5",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 6,
                        total: 11,
                    },
                ],
            },
        ],
    },
    "AP Spanish Language and Culture": {
        max: 150,
        scores: [0, 71, 86, 99, 117],
        sections: [
            {
                name: "Section 1",
                time: 95,
                sectionPoints: 65,
                sectionTotal: 76,
                breakdown: [
                    {
                        name: "Multiple Choice - Section 1A",
                        type: ExamTypeEnum.MCQ,
                        points: 30,
                        total: 35,
                    },
                    {
                        name: "Multiple Choice - Section 1B",
                        type: ExamTypeEnum.MCQ,
                        points: 35,
                        total: 41,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 92,
                sectionPoints: 20,
                sectionTotal: 74,
                breakdown: [
                    {
                        name: "Free Response - Interpersonal Writing",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 18.5,
                    },
                    {
                        name: "Free Response - Presentational Writing",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 18.5,
                    },
                    {
                        name: "Free Response - Interpersonal Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 5,
                        total: 18.5,
                    },
                    {
                        name: "Free Response - Presentational Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 18.5,
                    },
                ],
            },
        ],
    },
    "AP Spanish Literature and Culture": {
        max: 200,
        scores: [0, 72, 86, 120, 136],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 70,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 30,
                        total: 46,
                    },
                    {
                        name: "Multiple Choice with Audio",
                        type: ExamTypeEnum.MCQ,
                        points: 40,
                        total: 54,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 90,
                sectionPoints: 20,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Free Response - Email Reply",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 25,
                        // Note: The College Board specifies different FRQ categories (e.g., text analysis, comparison).
                    },
                    {
                        name: "Free Response - Argumentative Essay",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 25,
                    },
                    {
                        name: "Free Response - Spoken Conversation",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 5,
                        total: 25,
                        // Note: This should likely be "Analysis of a Single Text" per College Board guidelines.
                    },
                    {
                        name: "Free Response - Presentational Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 5,
                        total: 25,
                        // Note: This should likely be "Text Comparison" per College Board guidelines.
                    },
                ],
            },
        ],
    },
    "AP Japanese Language and Culture": {
        max: 200,
        scores: [0, 72, 86, 120, 136],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 75,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Multiple Choice with Audio",
                        type: ExamTypeEnum.MCQ,
                        points: 35,
                        total: 50,
                    },
                    {
                        name: "Multiple Choice with Readings",
                        type: ExamTypeEnum.MCQ,
                        points: 40,
                        total: 50,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 40,
                sectionPoints: 20,
                sectionTotal: 80,
                breakdown: [
                    {
                        name: "Free Response - Text Chat",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 20,
                    },
                    {
                        name: "Free Response - Comparison Essay",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 5,
                        total: 20,
                    },
                    {
                        name: "Free Response - Spoken Conversation",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 5,
                        total: 20,
                    },
                    {
                        name: "Free Response - Presentational Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 20,
                    },
                ],
            },
        ],
    },
    "AP Chinese Language and Culture": {
        max: 200,
        scores: [0, 62, 78, 114, 136],
        sections: [
            {
                name: "Section 1",
                time: 80,
                sectionPoints: 75,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Multiple Choice with Audio",
                        type: ExamTypeEnum.MCQ,
                        points: 35,
                        total: 50,
                    },
                    {
                        name: "Multiple Choice with Readings",
                        type: ExamTypeEnum.MCQ,
                        points: 40,
                        total: 50,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 41,
                sectionPoints: 22,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Free Response - Written 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 6,
                        total: 25,
                    },
                    {
                        name: "Free Response - Written 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 6,
                        total: 25,
                    },
                    {
                        name: "Free Response - Spoken 1",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 6,
                        total: 25,
                    },
                    {
                        name: "Free Response - Spoken 2",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 4,
                        total: 25,
                    },
                ],
            },
        ],
    },
    "AP Italian Language and Culture": {
        max: 200,
        scores: [0, 72, 86, 120, 136],
        sections: [
            {
                name: "Section 1",
                time: 95,
                sectionPoints: 70,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Multiple Choice",
                        type: ExamTypeEnum.MCQ,
                        points: 30,
                        total: 46,
                    },
                    {
                        name: "Multiple Choice with Audio",
                        type: ExamTypeEnum.MCQ,
                        points: 40,
                        total: 54,
                    },
                ],
            },
            {
                name: "Section 2",
                time: 92,
                sectionPoints: 20,
                sectionTotal: 100,
                breakdown: [
                    {
                        name: "Free Response - Email Reply",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 25,
                    },
                    {
                        name: "Free Response - Argumentative Essay",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.LEQ,
                        points: 5,
                        total: 25,
                    },
                    {
                        name: "Free Response - Spoken Conversation",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ, // Original type was SS, replaced with SAQ as SS is not valid.
                        points: 5,
                        total: 25,
                    },
                    {
                        name: "Free Response - Presentational Speaking",
                        type: ExamTypeEnum.FRQ,
                        frqType: ExamFRQType.SAQ,
                        points: 5,
                        total: 25,
                    },
                ],
            },
        ],
    },
};
